import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const normalizedPath = pathname.replace(/\/$/, '');

    // Only skip scroll-to-top if we are navigating TO the specific page that is restoring its scroll position
    if (normalizedPath === '/dashboard' && sessionStorage.getItem('dashboardScrollY')) {
      return;
    }
    if (normalizedPath === '/collection' && sessionStorage.getItem('collectionScrollY')) {
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;